module.exports = __webpack_public_path__ + "img/36.9667b365.png";